import React from "react";
import { UserMessageProps } from "@copilotkit/react-ui";

const CustomUserMessage: React.FC<UserMessageProps> = (props: UserMessageProps) => {
  return (
    <div className="flex items-start mb-4 justify-end">
      <div className="flex flex-col items-end">
        <div className="flex items-center gap-x-2 rounded-t-lg bg-gray-600 px-4 py-2 text-sm font-semibold text-white dark:bg-gray-700">
          You
        </div>
        <div className="rounded-b-md  rounded-tl-md bg-gray-200 px-5 py-2 text-gray-700 dark:bg-white dark:text-gray-800 text-right">
          <p className="whitespace-pre-wrap">{props.message}</p>
        </div>
      </div>
    </div>
  );
};

export default CustomUserMessage;
